// extracted by mini-css-extract-plugin
export default {"item":"Modal_item__2LqQN"};